import posthog from 'posthog-js';

// Only initialize when rendered inside an iframe
if (window.self !== window.top) {
  posthog.init('phc_oNoyLx73nwdgrC1OMk0cVk8p67aAsO1U9PrhBrqEGwT', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-01-30',
    session_recording: {
      recordCrossOriginIframes: true,
    },
  });
}
